// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import AxiosPlugin from './libs/AxiosPlugin';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import DialogPlugin from './widget/dialog/DialogPlugin';
// 引入http封装
import http from './libs/http'
import util from './libs/util'
import store from './store'
Vue.prototype.$http = http;
Vue.prototype.$util = util;
Vue.prototype.$store = store
// Vue.use(AxiosPlugin);
Vue.use(iView);
Vue.use(DialogPlugin);
Vue.config.productionTip = false

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js